import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { FilterModel } from 'ag-grid-community';
import { InvoiceFirestoreService } from '../../services/invoice.firestore.service';
import { InvoiceActions } from './invoice.action';
import { InvoiceStateModel } from './invoice.store';

@State<InvoiceStateModel>({
  name: 'invoices',
  defaults: {
    invoices: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class InvoiceState {
  private invoicesService = inject(InvoiceFirestoreService);
  // private invoiceState = inject(InvoiceState);
  // private dbInvoice = inject(OrmService).invoiceCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(InvoiceActions.GetAllInvoices)
  async getAllInvoices(ctx: StateContext<InvoiceStateModel>) {
    ctx.patchState({ isLoading: true });
    const invoices = await this.invoicesService.GetAll();
    ctx.patchState({
      invoices: invoices.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(InvoiceActions.UpdateInvoice)
  async updateInvoice(ctx: StateContext<InvoiceStateModel>, { invoiceData, ref }: InvoiceActions.UpdateInvoice) {
    await this.invoicesService.Update(ref, invoiceData);
  }

  @Action(InvoiceActions.UpdateInvoiceResult)
  updateInvoiceResult(ctx: StateContext<InvoiceStateModel>, { data }: InvoiceActions.UpdateInvoiceResult) {
    patchState<InvoiceStateModel>(ctx, 'invoices', data);
  }

  @Action(InvoiceActions.PaginateQueryInvoice)
  async queryInvoice(
    ctx: StateContext<InvoiceStateModel>,
    { request, isResetAfterFilterOrSort }: InvoiceActions.PaginateQueryInvoice,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['invoiceId']) {
    //   (request.filterModel as FilterModel)['invoiceId']['values'] = (request.filterModel as FilterModel)[
    //     'invoiceId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(InvoiceState.invoices).find((invoice) => invoice.companyName === v)?.ref
    //   );
    // }
    // if (invoiceId) {
    //   request.filterModel = {
    //     invoiceId: { filter: this.dbInvoice.ref(this.dbInvoice.id(invoiceId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.invoicesService.SetQuery({
      ...request,
      count: state.invoices.length,
      data: state.invoices,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.invoices.length;
      state.invoices = [];
      state.invoices.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.invoices = [];
      state.invoices.length = await this.invoicesService.GetBuildedCount(runs);
    }
    if (state.invoices.length !== 0) {
      runs.push(...this.invoicesService.SetLimit({ ...request, count: state.invoices.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const invoices = await this.invoicesService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        invoices.reverse().forEach(
          ({ data, ref }, i) =>
            (state.invoices[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        invoices.forEach(
          ({ data, ref }, i) =>
            (state.invoices[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, invoices: state.invoices });
  }

  @Action(InvoiceActions.InvoiceError)
  invoicesError(ctx: StateContext<InvoiceStateModel>, { error }: InvoiceActions.InvoiceError) {
    console.error({ error });
    // await this.invoicesService.Update(id, invoicesData);
  }

  @Action(InvoiceActions.DeleteInvoices)
  async deletetinvoices(ctx: StateContext<InvoiceStateModel>, { refs }: InvoiceActions.DeleteInvoices) {
    await this.invoicesService.BatchDelete(refs);
  }

  @Action(InvoiceActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<InvoiceStateModel>,
    { fields, timePeriod, filterModel }: InvoiceActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (invoiceId) {
    //   filterModel = { invoiceId: { filter: this.dbInvoice.ref(this.dbInvoice.id(invoiceId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.invoicesService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.invoicesService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.invoicesService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static invoices(state: InvoiceStateModel) {
    return state.invoices;
  }
  @Selector()
  static invoicesCount(state: InvoiceStateModel) {
    return state.invoices.length;
  }

  @Selector()
  static sums(state: InvoiceStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: InvoiceStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static invoicesState(state: InvoiceStateModel) {
    return state;
  }
}
